export default __webpack_public_path__ + "static/media/percorsi.61fb88ac.png";